var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#4A2FBD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M65.7364 31.4997L36.4912 2.08329C35.6816 1.26989 34.584 0.812988 33.4396 0.812988C32.2951 0.812988 31.1975 1.26989 30.3879 2.08329L24.3071 8.19366L32.0121 15.9418C36.059 14.5672 39.8905 18.4638 38.5012 22.5108L45.928 29.9792C51.0472 28.2046 55.0777 34.6413 51.2327 38.5049C47.271 42.4887 40.7325 38.0733 42.8577 32.8893L35.9259 25.9277V44.2528C39.7096 46.1387 39.2549 50.5467 37.2838 52.5243C36.3208 53.4922 35.015 54.0359 33.6534 54.0359C32.2919 54.0359 30.986 53.4922 30.023 52.5243C27.3953 49.8774 28.3674 45.4695 31.7055 44.1024V25.6044C28.5948 24.3246 28.0265 20.9814 28.9178 18.8368L21.322 11.1894L1.26385 31.3628C0.45461 32.1768 0 33.2806 0 34.4316C0 35.5825 0.45461 36.6863 1.26385 37.5003L30.518 66.9167C31.3274 67.73 32.4247 68.1868 33.5689 68.1868C34.7131 68.1868 35.8105 67.73 36.6198 66.9167L65.7364 37.6371C66.5456 36.8232 67.0003 35.7194 67.0003 34.5684C67.0003 33.4174 66.5456 32.3136 65.7364 31.4997Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.e318862cdce0cafa2c398a25d75fb73d.svg";
export { ForwardRef as ReactComponent };